import { User } from "../@core/data/users";
import { Person } from "./person.model";

export class Employee {
  id?: string;
  email?: string;
  mobile?: string;
  cardId?: string;

  fullName?: string;
  firstName?: string;
  lastName?: string;
  dob?: Date;
  dobYear?: number;
  dobMonth?: number;
  dobDay?: number;
  gender?: string;

  address?: string;
  description?: string;
  tax?: string;

  tags?: string[];
  coverUrl?: string;

  sourceType?: string; //video/images/document
  content?: string; //document
  videoUrl?: string; //video
  imagesUrl?: string[]; //images
  isDefault?: boolean;
  isCounSellor?: boolean;
  isSeller?: boolean;
  isDeliverer?: boolean;

  //List contacts
  contacts?: EmployeeContacts[];

  //Overview
  saleQuantity?: number;
  saleAmount?: number;
  noHistory?: number;

  shopId?: string;
  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}

export class EmployeeContacts {
  id?: string;
  role?: string;
  description?: string;
  person?: Person;

  //default
  timestamp?: number;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
}
